import React, { Component } from 'react';
import BusinessIdeaPage from '../../../components/CompanyNamePage/BusinessIdeaPage';
import { createMainController } from '../../../services/createMainController';
import { biLogSafe } from '../../../../universal/biService';

class BusinessIdeaController extends Component {
  onBusinessIdeaChange = value => {
    const { setBusinessIdea } = this.props;
    setBusinessIdea(value);
  };

  componentDidMount() {
    const { selectors } = this.props;
    const referralInfo = selectors.getReferralInfo();

    biLogSafe(biLogger => {
      biLogger('businessNameGeneratorPageOpen', { origin: referralInfo, pageName: 'Business-name' });
    });
  }

  onNextHandler = () => {
    const { selectors } = this.props;
    const businessIdea = selectors.getBusinessIdea();
    const referralInfo = selectors.getReferralInfo();
    const { setLogoListSearchAndGoToTagsSelector } = this.props;
    setLogoListSearchAndGoToTagsSelector();
    biLogSafe(biLogger => {
      biLogger('businessNameGeneratorButtonClick', {
        origin: referralInfo,
        pageName: 'Business-name',
        buttonName: 'Next',
        additionalInfo: JSON.stringify({ businessName: businessIdea })
      });
    });
  };
  render() {
    const { t, selectors } = this.props;
    const businessIdea = selectors.getBusinessIdea();
    return (
      <BusinessIdeaPage
        businessIdea={businessIdea}
        onNext={this.onNextHandler}
        onBusinessIdeaChange={this.onBusinessIdeaChange}
        placeHolderText={t('BNG_ON_BOARDING_DETAILS_NAME_PLACEHOLDER')}
        nextButtonText={t('BNG_ON_BOARDING_NEXT_BUTTON')}
        t={t}
      />
    );
  }
}

export default createMainController(BusinessIdeaController);
